import { IEventDetailsDTO } from '../../../../../../api/events.dao';
import { IScheduledEmailsListDTO, ITrackingEmailValues, ScheduledTypes } from '../../../../../../api/scheduled-email.dao';
import { ISubWindowFacade } from '../../../../../../infrastructure/sub-windows';
import { TObject } from '../../../../../../infrastructure/type-extensions';
import { capitalizeFirstLetter } from '../../../../../../infrastructure/utils/string.utils';
import { ScheduledEmailForm } from './scheduled-email-form/scheduled-email-form';
import { ScheduledEmailsFormBaseVM } from './scheduled-emails-form-base.viewmodel';
import { CONFIGURE_EMAIL_TEXT } from './scheduled-emails-form.texts';

class ScheduledEventEmailsVM extends ScheduledEmailsFormBaseVM {
    public readonly type: ScheduledTypes = ScheduledTypes.Event;

    constructor(
        protected accountId: number,
        protected _event: IEventDetailsDTO,
        eventEmails: IScheduledEmailsListDTO,
        emailIdToEditPopupMap: TObject<ISubWindowFacade>,
    ) {
        super(accountId, _event, eventEmails, emailIdToEditPopupMap);
    }

    public onEditAction = (id: string): void => {
        super.showScheduledEmailForm(id);
    };

    public onCreateAction = (): void => {
        super.showScheduledEmailForm(null);
    };

    protected openNewSubWindow(id: string): void {
        const facade = this.subWindowsService.showSubWindow({
            withExpand: true,
            title: this.intl.formatMessage(CONFIGURE_EMAIL_TEXT),
            componentToHost: ScheduledEmailForm,
            componentToHostProps: {
                saveCompletionCallback: super.onSaveCompleted,
                updateCompletionCallback: super.onUpdateCompleted,
                accountId: this.accountId,
                event: this.event,
                type: this.type,
                scheduledEmailDTO: super.findEmailById(id),
            },
        });

        if (id) super.setEmailIdToEditPopupMap(id, facade);
    };

    protected emailTrackingData = (dateTime: Date): ITrackingEmailValues => {
        return {
            ...super.emailTrackingData(dateTime),
            'Email Type': capitalizeFirstLetter(this.type),
        };
    };
}

export { ScheduledEventEmailsVM };
